<template>
  <div class="img">
    <!-- v-decorator="[
        'videoFull',
        {rules: [{ required: true, message: '请上传视频' }]},
      ]"-->
    <a-upload
      listType="picture-card"
      class="face-picture"
      :showUploadList="false"
      :headers="headers"
      :beforeUpload="videoBeforeUpload"
    >
      <!-- <span v-if="!videoFull.obsObjectKey&&!uploadLoading">请上传</span> -->
      <div v-if="uploadLoading">
        <a-icon type="loading" />
        <div class="ant-upload-text">{{ progress }}%</div>
      </div>
      <div v-if="uploadLoading&&progress==100 || !uploadLoading&&videoFull.obsObjectKey">
        <div class="ant-upload-text">{{ videoFull.obsName }}</div>
      </div>
      <div v-if="!uploadLoading&&!videoFull.obsObjectKey&&progress==0">
        <a-icon type="plus" />
        <div class="ant-upload-text">请上传</div>
      </div>
    </a-upload>
    <!-- <a-upload
      name="file"
      listType="picture-card"
      :multiple="isMultiple"
      :action="uploadAction"
      :headers="headers"
      :data="{biz:bizPath}"
      :fileList="fileList"
      :beforeUpload="beforeUpload"
      :disabled="disabled"
      :isMultiple="isMultiple"
      :showUploadList="isMultiple"
      @change="handleChange"
      @preview="handlePreview"
      :class="!isMultiple?'imgupload':''">
      <div :style="{'width':(!isMultiple?'104px':'auto'),'height':(!isMultiple?'104px':'auto')}">
        <img v-if="!isMultiple && picUrl" :src="getAvatarView()" style="width:100%;height:100%"/>
        <div v-else class="iconp">
          <a-icon :type="uploadLoading ? 'loading' : 'plus'" />
          <div class="ant-upload-text">{{ text }}</div>
        </div>
      </div>
      <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel()">
        <img alt="example" style="width: 100%" :src="previewImage"/>
      </a-modal>
    </a-upload> -->
  </div>
</template>

<script>
  import Vue from 'vue'
  import { ACCESS_TOKEN, TENANT_ID } from '@/store/mutation-types'
  import { getFileAccessHttpUrl } from '@/api/manage'

  import { createUploadVideo } from '@/api/api'

  import { initVideoUploder } from '@/utils/util'

  export default {
    name: 'JVideoUpload',
    data() {
      return {
        uploadLoading: false,
        picUrl: false,
        headers: {},
        fileList: [],
        uploader: {},
        progress: 0,
        uploadInfo: {},
        videoFull: {}
      }
    },
    props: {
      value: {
        type: Object,
        required: false
      }
    },
    watch: {
      value: {
        handler(nv, ov) {
          this.videoFull = nv || {}
        },
        immediate: true,
        deep: true
      }
    },
    created() {
      const token = Vue.ls.get(ACCESS_TOKEN)
      let tenantid = Vue.ls.get(TENANT_ID)
      this.initUploader()

      this.headers = { 'X-Access-Token': token, 'tenant_id': tenantid }
    },
    methods: {
      getUploadInfo (file) {
        createUploadVideo({
          title: file.name,
          fileName: file.name
        }).then((res) => {
              if (res.success) {
                this.progress = 0
                this.uploadLoading = true
                this.uploadInfo = res.result || {}
                this.uploadInfo['file'] = file
                this.uploader.addFile(file, null, null, null)
                this.uploader.startUpload()
              } else {
                this.$message.warning(res.message)
              }
            }).finally(() => {
            })
      },
      initUploader () {
        let that = this
        that.uploader = initVideoUploder({
            onUploadstarted: (uploadInfo) => {
              that.uploader.setUploadAuthAndAddress(uploadInfo, that.uploadInfo.uploadAuth, that.uploadInfo.uploadAddress, that.uploadInfo.videoId)
            },
            onUploadProgress: (uploadInfo, totalSize, loadedPercent) => {
              console.log(loadedPercent)
              that.progress = Math.ceil(loadedPercent * 100)
            },
            onUploadTokenExpired: (uploadInfo) => {
              that.uploader.resumeUploadWithAuth(that.uploadInfo.uploadAuth)
            },
            onUploadEnd: (uploadInfo) => { //
              that.uploadLoading = false
              that.videoFull = {
                obsName: that.uploadInfo.file.name,
                obsObjectKey: that.uploadInfo.videoId
              }
              // that.setFieldsValue('videoFull', that.videoFull)
              this.$emit('change', that.videoFull)
            }
          }
        )
      },
      videoBeforeUpload (file) {
        const isJPG = /\.(mp4)$/.test(file.name)

        if (!isJPG) {
          this.$message.error('只能上传mp4视频!')
          return
        }

        const isLt10M = file.size / 1024 / 1024 <= 2048
        if (!isLt10M) {
          this.$message.error('视频大小要小于2G!')
          return
        }

        this.getUploadInfo(file)

        return false
      },
      // 预览
      handlePreview (file) {
        this.previewImage = file.url || file.thumbUrl
        this.previewVisible = true
      },
      getAvatarView() {
        if (this.fileList.length > 0) {
          let url = this.fileList[0].url
          return getFileAccessHttpUrl(url)
        }
      },
      handlePathChange() {
        let uploadFiles = this.fileList
        let path = ''
        if (!uploadFiles || uploadFiles.length == 0) {
          path = ''
        }
        let arr = []
        if (!this.isMultiple) {
          arr.push(uploadFiles[uploadFiles.length - 1].response.result.obsObjectUrl)
        } else {
          for (let a = 0; a < uploadFiles.length; a++) {
            // update-begin-author:taoyan date:20200819 for:【开源问题z】上传图片组件 LOWCOD-783
            if (uploadFiles[a].status === 'done') {
              arr.push(uploadFiles[a].response.message)
            } else {
              return
            }
            // update-end-author:taoyan date:20200819 for:【开源问题z】上传图片组件 LOWCOD-783
          }
        }
        if (arr.length > 0) {
          path = arr.join(',')
        }
        this.$emit('change', path)
      },
      handleDelete(file) {
        // 如有需要新增 删除逻辑
        console.log(file)
      },
      handleCancel() {
        this.close()
        this.previewVisible = false
      },
      close () {

      }
    },
    model: {
      prop: 'value',
      event: 'change'
    }
  }
</script>

<style scoped>
  /* update--begin--autor:lvdandan-----date:20201016------for：j-image-upload图片组件单张图片详情回显空白
  * https://github.com/zhangdaiscott/jeecg-boot/issues/1810
  * https://github.com/zhangdaiscott/jeecg-boot/issues/1779
  */
  /deep/ .imgupload .ant-upload-select{display:block}
  /deep/ .imgupload .ant-upload.ant-upload-select-picture-card{ width:120px;height: 120px;}
  /deep/ .imgupload .iconp{padding:32px;}
  /* update--end--autor:lvdandan-----date:20201016------for：j-image-upload图片组件单张图片详情回显空白*/
</style>
